import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import Select from "react-select";

import { Code } from '@mui/icons-material';

import MainTab from './Tabs/MainTab';
import BranchTab from './Tabs/BranchTab';

const DraftAdd = ({ accessedModules, accessedPermission }) => {

const columns = [
{ title: "Currency", dataIndex: "SNo", key: "SNo" },
{ title: "Code", dataIndex: "Code", key: "Code" },
{ title: "Sell Rate", dataIndex: "Prefix", key: "Prefix" },
{ title: "Buy Rate", dataIndex: "CheckDigit", key: "CheckDigit" },
];

return (
<>
    <div className="page-wrapper">
        <div className="content">

            <div className="card py-5">

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 d-grid" style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                            <label htmlFor="effectiveFrom" className="form-label mb-0">Ref No.</label>
                            <div className="icon-forms mb-3">
                                <input type="text" id="effectiveFrom" className="form-control form-control-sm"
                                    placeholder='--New Entry--' />
                            </div>
                        </div>

                        <div className="col-md-12 d-grid" style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                            <label htmlFor="effectiveFrom" className="form-label mb-0">Title</label>
                            <div className="icon-forms mb-3">
                                <input type="text" id="effectiveFrom" className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="col-md-12 d-grid" style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                            <label htmlFor="effectiveFrom" className="form-label mb-0">Notes</label>
                            <div className="icon-forms mb-3">
                                <textarea id="effectiveFrom" className="form-control " row='4'></textarea>
                            </div>
                        </div>

                        
                            <div className="col-md-12 d-grid" style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="searchFor" className="form-label mb-0">Tags</label>
                                <div className="icon-forms mb-3">
                                    <input type="text" id="searchFor" className="form-control form-control-sm"
                                        placeholder="Enter keyword" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid" style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="uploadFile" className="form-label mb-0">Attachment <br /> <sub>(max size 976.56 mb)</sub> </label>
                                <div className="icon-forms mb-3">
                                    <input type="file" id="uploadFile" className="" />
                                </div>
                            </div>
                        

                    </div>

                    {/* Filter */}
                    <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">

                        </div>
                    </div>
                    {/* /Filter */}
                    {/* Contact List */}

                    {/* <div className="row">
                        <div className="table-responsive custom-table">
                            <Table className="table datanew dataTable no-footer" pagination={false} columns={columns} />
                        </div>
                    </div> */}
                    {/* <div className="row-gap-2">
                        <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="Service-tab" data-bs-toggle="pill"
                                    data-bs-target="#Service" type="button" role="tab" aria-controls="Service"
                                    aria-selected="true">Main</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="Entity-tab" data-bs-toggle="pill"
                                    data-bs-target="#Entity" type="button" role="tab" aria-controls="Entity"
                                    aria-selected="false">Branch</button>
                            </li>

                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="Service" role="tabpanel"
                                aria-labelledby="Service-tab">
                                <MainTab />
                            </div>
                            <div className="tab-pane fade" id="Entity" role="tabpanel" aria-labelledby="Entity-tab">
                                <BranchTab />
                            </div>
                        </div>
                    </div> */}

                    {/*
                    <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset}
                        dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount}
                        setCurrentData={setCurrentData} currentData={currentData} />
</>
} */}
{/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
    <button className='' onClick={()=> handlePageChange(count - 1)}
        disabled={count === 1}
        >
        <img src="/img/right.png" className='mx-2' alt="right" />
    </button>

    {pageNumbers.map((number, index) =>
    number === '...' ? (
    <span key={index} className="mx-2">...</span>
    ) : (
    <span key={number} className={`search-btn-1 ${number===count ? 'active' : '' }`} onClick={()=>
        handlePageChange(number)}
        style={{ cursor: 'pointer' }}
        >
        {number}
    </span>
    )
    )}

    <button onClick={()=> handlePageChange(count + 1)}
        disabled={count === totalPages}
        >
        <img src="/img/left.png" className='mx-2' alt="right" />
    </button>
</div> */}
<div className="d-flex justify-content-end gap-2 mt-2">
    {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
        {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
    </button> */}
    <button className="btn btn-primary text-xs" type="submit">
        Submit
    </button>
    <button className="btn btn-primary text-xs" type="submit">
        Save & Close
    </button>
    <button className="btn btn-primary text-xs" type="submit">
        Save & New
    </button>
    <button className="btn btn-light text-xs" type="submit">
        Close
    </button>
</div>
</div>
</div>
</div>
</div>
{/*
<AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
<EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
{/*
<EditEmployee id="offcanvas_edit" />
<AddEmployee id="offcanvas_add" /> */}
{/*
<CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

<EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
</>

)
}

export default DraftAdd